const content = {
  footer: {
    headline1: 'Live for',
    headline2: 'your story.',
    socials: [
      { label: 'Instagram', url: 'https://www.instagram.com/tyron.shi/' },
      { label: 'TikTok', url: 'https://www.tiktok.com/@tyron.shi' },
      { label: 'YouTube', url: 'https://www.youtube.com/@tyronshi' },
      { label: 'X', url: 'https://x.com/tyron_shi' },
      {
        label: 'Apple Music',
        url: 'https://music.apple.com/us/artist/tyron/1331235344',
      },
      {
        label: 'Spotify',
        url: 'https://open.spotify.com/artist/5SMwJ4GtRRsLWN5SCJcc8u',
      },
    ],
    backgroundImage:
      'https://storage.googleapis.com/tyronshi/images/footer-bg-061626/image-2160.webp',
  },
};
export default content;
